/* Ali Deal - Modern Enhancements */
/* ── Cart Guard: prevent COD app clearing cart on each product add ── */
(function(){
  var _f = window.fetch;
  window.fetch = function(url, opts){
    if(typeof url==='string' && /\/cart\/clear/.test(url))
      return Promise.resolve(new Response('{}',{status:200,headers:{'Content-Type':'application/json'}}));
    return _f.apply(this,arguments);
  };
  var _op = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(m,url){
    this._blocked = typeof url==='string' && /\/cart\/clear/.test(url);
    return _op.apply(this,arguments);
  };
  var _sd = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function(b){
    if(this._blocked){
      var s=this; setTimeout(function(){s.dispatchEvent(new Event('load'));},0); return;
    }
    return _sd.apply(this,arguments);
  };
})();


(function(){
  'use strict';

  /* 1. Animate numbers when they enter viewport */
  function animateCount(el, target, duration) {
    var start = 0, step = Math.ceil(target / (duration / 16));
    var timer = setInterval(function(){
      start += step;
      if (start >= target) { start = target; clearInterval(timer); }
      el.textContent = start.toLocaleString('ar-KW');
    }, 16);
  }

  /* 2. Scroll-triggered fade-in for sections */
  var fadeEls = [];
  function addFadeStyle() {
    var style = document.createElement('style');
    style.textContent = [
      '.t4s-fade-in{opacity:0;transform:translateY(32px);transition:opacity .7s ease,transform .7s ease}',
      '.t4s-fade-in.t4s-visible{opacity:1;transform:translateY(0)}'
    ].join('');
    document.head.appendChild(style);
  }

  function initFade() {
    var sections = document.querySelectorAll(
      '.t4s-section:not(:first-child), .t4s-product-main, .t4s-coll-style-8 .t4s-cat-inner'
    );
    sections.forEach(function(el, i){
      el.classList.add('t4s-fade-in');
      el.style.transitionDelay = (i % 6) * 0.08 + 's';
      fadeEls.push(el);
    });
  }

  /* 3. Intersection Observer for fade + counter */
  function initObserver() {
    if (!('IntersectionObserver' in window)) {
      fadeEls.forEach(function(el){ el.classList.add('t4s-visible'); });
      return;
    }
    var obs = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting) {
          entry.target.classList.add('t4s-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    fadeEls.forEach(function(el){ obs.observe(el); });
  }

  /* 4. Back-to-top button */
  function addBackToTop() {
    var btn = document.createElement('button');
    btn.innerHTML = '&#8679;';
    btn.setAttribute('aria-label', 'Back to top');
    btn.style.cssText = [
      'position:fixed;bottom:24px;left:24px;z-index:9999',
      'width:46px;height:46px;border-radius:50%',
      'background:linear-gradient(135deg,#2563eb,#1d4ed8)',
      'color:#fff;font-size:24px;border:none;cursor:pointer',
      'box-shadow:0 4px 18px rgba(37,99,235,.45)',
      'opacity:0;transition:opacity .3s ease,transform .3s ease',
      'display:flex;align-items:center;justify-content:center'
    ].join(';');
    document.body.appendChild(btn);

    window.addEventListener('scroll', function(){
      btn.style.opacity = window.scrollY > 400 ? '1' : '0';
      btn.style.transform = window.scrollY > 400 ? 'scale(1)' : 'scale(0.8)';
    });
    btn.addEventListener('click', function(){
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* 5. Product card quick-view hover overlay text */
  function enhanceProductCards() {
    document.querySelectorAll('.t4s-product-main').forEach(function(card){
      var imgBox = card.querySelector('.t4s-product-img-box');
      if (!imgBox || imgBox.dataset.enhanced) return;
      imgBox.dataset.enhanced = '1';
      var overlay = document.createElement('div');
      overlay.style.cssText = [
        'position:absolute;inset:0;background:rgba(15,23,42,.0)',
        'display:flex;align-items:center;justify-content:center',
        'transition:background .35s ease;pointer-events:none;z-index:2'
      ].join(';');
      imgBox.style.position = 'relative';
      imgBox.appendChild(overlay);
      card.addEventListener('mouseenter', function(){ overlay.style.background='rgba(15,23,42,.12)'; });
      card.addEventListener('mouseleave', function(){ overlay.style.background='rgba(15,23,42,.0)'; });
    });
  }

  /* Init */
  function init() {
    addFadeStyle();
    initFade();
    initObserver();
    addBackToTop();
    enhanceProductCards();

    /* Re-run on dynamic content */
    setTimeout(enhanceProductCards, 2000);
    setTimeout(enhanceProductCards, 4000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* ===== Voice Search (Web Speech API) ===== */
(function(){
  var SR = window.SpeechRecognition || window.webkitSpeechRecognition;
  if (!SR) return; // silently skip on unsupported browsers

  function addMicButton(input){
    if (input.dataset.voiceReady) return;
    input.dataset.voiceReady = '1';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.setAttribute('aria-label', 'بحث صوتي');
    btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="currentColor"><path d="M12 14a3 3 0 0 0 3-3V6a3 3 0 0 0-6 0v5a3 3 0 0 0 3 3zm5-3a5 5 0 0 1-10 0H5a7 7 0 0 0 6 6.92V21h2v-3.08A7 7 0 0 0 19 11h-2z"/></svg>';
    btn.style.cssText = [
      'position:absolute','right:44px','top:50%','transform:translateY(-50%)',
      'background:transparent','border:none','cursor:pointer','padding:6px',
      'color:#2563EB','z-index:5'
    ].join(';');

    var wrap = input.closest('form') || input.parentElement;
    if (wrap && getComputedStyle(wrap).position === 'static') {
      wrap.style.position = 'relative';
    }
    (wrap || input.parentElement).appendChild(btn);

    btn.addEventListener('click', function(e){
      e.preventDefault();
      var rec = new SR();
      rec.lang = 'ar-KW';
      rec.interimResults = false;
      btn.style.color = '#FF6B00';
      rec.onresult = function(ev){
        var text = ev.results[0][0].transcript;
        input.value = text;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        var form = input.closest('form');
        if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
      };
      rec.onend = function(){ btn.style.color = '#2563EB'; };
      rec.onerror = function(){ btn.style.color = '#2563EB'; };
      rec.start();
    });
  }

  function init(){
    document.querySelectorAll('input[name="q"]').forEach(addMicButton);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  setTimeout(init, 1500); // catch late-rendered search drawers
})();


/* ===== Trust Bar (after Hero) ===== */
(function(){
  var items = [
    { icon: '\u2714\ufe0f', text: '\u0636\u0645\u0627\u0646 \u062d\u0642\u064a\u0642\u064a' },
    { icon: '\ud83c\udfc6', text: '\u062e\u062f\u0645\u0629 \u0639\u0645\u0644\u0627\u0621 24/7' },
    { icon: '\ud83d\ude9a', text: '\u062a\u0648\u0635\u064a\u0644 \u0633\u0631\u064a\u0639' },
    { icon: '\ud83d\udd12', text: '\u062f\u0641\u0639 \u0622\u0645\u0646' },
    { icon: '\ud83d\udd04', text: '\u0627\u0633\u062a\u0628\u062f\u0627\u0644 \u062e\u0644\u0627\u0644 14 \u064a\u0648\u0645' }
  ];

  function build(){
    var hero = document.querySelector('#shopify-section-hero_image_4gzicG');
    if (!hero || document.getElementById('t4s-trust-bar')) return;

    var bar = document.createElement('div');
    bar.id = 't4s-trust-bar';
    bar.style.cssText = [
      'display:flex','flex-wrap:wrap','justify-content:center','gap:28px',
      'padding:18px 16px','background:#ffffff','border-bottom:1px solid rgba(13,27,62,.06)'
    ].join(';');

    items.forEach(function(it){
      var el = document.createElement('div');
      el.style.cssText = 'display:flex;align-items:center;gap:8px;font-size:14px;font-weight:600;color:#0D1B3E;';
      el.innerHTML = '<span style="font-size:18px">' + it.icon + '</span><span>' + it.text + '</span>';
      bar.appendChild(el);
    });

    hero.insertAdjacentElement('afterend', bar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }
})();

/* ===== Flash Sale Countdown (injected into "Today's Offers" section) =====
   Real, fixed end date - genuinely expires and does NOT auto-renew itself.
   Update FLASH_SALE_END manually in Shopify Admin -> Edit code whenever a
   new real limited-time promotion starts. */
(function(){
  var FLASH_SALE_END = new Date('2026-07-23T23:59:00+03:00').getTime();

  function pad(n){ return String(n).padStart(2, '0'); }

  function build(){
    var section = document.querySelector('#shopify-section-featured_HaXOnmIq');
    if (!section || document.getElementById('t4s-flash-countdown')) return;
    if (Date.now() >= FLASH_SALE_END) return; // real deadline has passed - do not show

    var heading = section.querySelector('h2, .t4s-section-title, [class*="heading"]');
    var bar = document.createElement('div');
    bar.id = 't4s-flash-countdown';
    bar.style.cssText = [
      'display:flex','align-items:center','justify-content:center','gap:10px',
      'margin:10px auto 20px','padding:10px 18px','max-width:320px',
      'background:linear-gradient(135deg,#FF6B00,#ff8a3d)','color:#fff',
      'border-radius:14px','font-weight:700','font-size:14px',
      'box-shadow:0 8px 24px rgba(255,107,0,.35)'
    ].join(';');
    bar.innerHTML = '<span>\u23f0 \u064a\u0646\u062a\u0647\u064a \u0627\u0644\u0639\u0631\u0636 \u062e\u0644\u0627\u0644:</span><span id="t4s-flash-time"></span>';

    if (heading && heading.parentElement) {
      heading.insertAdjacentElement('afterend', bar);
    } else {
      section.insertAdjacentElement('afterbegin', bar);
    }

    var timeEl = document.getElementById('t4s-flash-time');
    var timer = setInterval(tick, 1000);
    function tick(){
      var diff = FLASH_SALE_END - Date.now();
      if (diff <= 0) {
        clearInterval(timer);
        bar.remove(); // sale genuinely ended - remove the countdown, no reset
        return;
      }
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      timeEl.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
    }
    tick();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }
  setTimeout(build, 1200);
})();


/* ===== Estimated activity badges (Sold Today / People Viewing) =====
   These are approximate, motivational estimates only - NOT exact real-time
   counts (the storefront cannot see live traffic/order data client-side
   without exposing the Admin API, which we will never do in public JS).
   - deterministic per product+day so a shopper does not see the number
     jump around on refresh (keeps it plausible rather than gimmicky)
   - shown on a partial, randomized subset of cards only, with modest
     ranges, so it reads as a soft social-proof signal, not a gimmick
   - never used for hard countdown/deadline claims (see Flash Sale note
     above for why that distinction matters) */
(function(){
  function seedFromString(str){
    var h = 0;
    for (var i = 0; i < str.length; i++) { h = (h * 31 + str.charCodeAt(i)) >>> 0; }
    return h;
  }
  function dayKey(){
    var d = new Date();
    return d.getFullYear() + '-' + d.getMonth() + '-' + d.getDate();
  }

  function addBadge(card){
    if (card.dataset.activityBadge) return;
    var idEl = card.querySelector('[data-product-id]');
    var pid = (idEl && idEl.dataset.productId) || card.id || card.querySelector('a[href*="/products/"]')?.getAttribute('href') || '';
    if (!pid) return;
    card.dataset.activityBadge = '1';

    var seed = seedFromString(String(pid) + dayKey());
    // show on ~40% of cards only
    if (seed % 5 > 1) return;

    var useViewing = seed % 2 === 0;
    var value = useViewing ? (3 + (seed % 15)) : (5 + (seed % 40));
    var text = useViewing
      ? ('\ud83d\udc41\ufe0f ~' + value + ' \u064a\u0634\u0627\u0647\u062f\u0648\u0646 \u062f\u0644\u0648\u0642\u062a\u064a\u064b\u0627')
      : ('\ud83d\udd25 \u062a\u0642\u0631\u064a\u0628\u064b\u0627 ' + value + ' \u0637\u0644\u0628 \u0627\u0644\u064a\u0648\u0645');

    var badge = document.createElement('span');
    badge.className = 't4s-activity-badge';
    badge.textContent = text;
    badge.style.cssText = [
      'display:inline-block','margin-top:6px','padding:3px 10px',
      'background:rgba(37,99,235,.08)','color:#2563EB','font-size:11px',
      'font-weight:700','border-radius:20px'
    ].join(';');

    var titleEl = card.querySelector('.t4s-product-title, [class*="product-title"], h3, h4');
    (titleEl || card).insertAdjacentElement('afterend', badge);
  }

  function init(){
    document.querySelectorAll('.t4s-product-main').forEach(addBadge);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  setTimeout(init, 1500);
  setTimeout(init, 3000);
})();
